<template>
  <v-app>
    <core-multi-lang />
<v-container
    fill-height
    fluid
    grid-list-xl
    class="main-layout_inner"
  >
    <v-layout
      justify-center
      wrap
    >
      <!-- inline edit table -->
      <v-flex xs12>

        <v-flex xs12 class="pt-0">
          <h3 class="main_title mb-5">{{ $t('Checkin.please-start-the-check-in') }}</h3>
          <p>{{ $t('Checkin.japanese-laws-and-ordinances') }}</p>
        </v-flex>

      </v-flex>
    </v-layout>
    <div class="main_btn">
          <v-btn block class="btn-custom btn-custom-main" v-on:click="handleSubmit()"
          >{{ $t('Checkin.next') }}</v-btn>
        </div>
  </v-container>
  </v-app>
</template>

<style lang="scss">
  .next-screen-btn {
    background-color: rgb(97 110 126) !important;
    color: #fff;
  }
  .next-screen-btn span {
    font-weight : bold;
  }
</style>

<script>
  import { mapState } from 'vuex'
export default {
  data: () => ({
    userId : null,
    rsvId : null
  }),

  computed: {
    getEnterUploadPassportScreenUrl(){
      return 'guest-upload-passport'
    },
    ...mapState(['guestAuthStatus'])

  },

  created () {
    const userId = this.$store.state.guestReserve.userId;
    const rsvId = this.$store.state.guestReserve.rsvId;

    this.userId = userId
    this.rsvId = rsvId
  },

  mounted(){

  },

  methods: {
    // 以前は未ログインなら無認証の personReset でパスワードを再発行し、そのまま personLogin
    // していた（宿泊者IDだけで入れた）。無認証の personReset は廃止する（DMS-1268-H）ので、
    // 未ログインならパスワードの入力と案内の画面（change-password）へ戻す。
    // この画面へ遷移する箇所は無く、URL を直接開いたときだけ表示される
    handleSubmit(){
      if(this.guestAuthStatus){
        this.$router.push(this.getEnterUploadPassportScreenUrl)
      }else if(this.rsvId && this.userId){
        this.$router.push("/change-password/" + this.rsvId + "?userId=" + this.userId)
      }else{
        this.$router.push("/error-page")
      }
    },
  }
}
</script>

<style lang="scss">
</style>
